<template>
    <v-container>
        <v-layout>
            <v-flex xs12 md12 class="name">{{ $store.getters[ 'persons/getContactTypeById'](role.contact_type_id).name | i18n }}<div v-show="remove" class="remove" @click="fnRemove">{{ 'remove' | i18n }}</div></v-flex>
            <v-flex xs12 md12  class="item">
                <div class="clear" style="height: 20px; position: relative; width: 100%"></div>
            </v-flex>
            <!-- JUGADOR -->
            <v-flex xs12 md12  v-if="parseInt( role.contact_type_id ) == 107" class="player">
                <v-container>
                    <v-layout row wrap class="section">
                        <v-flex xs12 md6 class="item">
                            <!-- <v-select v-if="item.type == 'autocomplete' && item.param != 'country_id' && item.param != 'nacionality'" v-model="data[ item.param ]" :label="item.label | i18n" :items="cAutoComplete[ item.param ]" @input.native="loadAutocomplete( $event, item )" autocomplete :disabled="false"></v-select> -->
                            <v-select v-model="role[ 'event_id' ]" :label="'params.event' | i18n" :items="events_active"  autocomplete :disabled="false"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <!-- <v-select v-if="item.type == 'autocomplete' && item.param != 'country_id' && item.param != 'nacionality'" v-model="data[ item.param ]" :label="item.label | i18n" :items="cAutoComplete[ item.param ]" @input.native="loadAutocomplete( $event, item )" autocomplete :disabled="false"></v-select> -->
                            <v-select v-show="role[ 'event_id' ] || event" v-model="role[ 'category_id' ]" :label="'params.category' | i18n" :items="categories" autocomplete :disabled="false"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <!-- <v-select v-if="item.type == 'autocomplete' && item.param != 'country_id' && item.param != 'nacionality'" v-model="data[ item.param ]" :label="item.label | i18n" :items="cAutoComplete[ item.param ]" @input.native="loadAutocomplete( $event, item )" autocomplete :disabled="false"></v-select> -->
                            <v-select v-show="role[ 'event_id' ] || event || role['club_id']" v-model="role[ 'club_id' ]" :label="'params.club' | i18n" :items="clubs" autocomplete :disabled="false"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <!-- <v-select v-if="item.type == 'autocomplete' && item.param != 'country_id' && item.param != 'nacionality'" v-model="data[ item.param ]" :label="item.label | i18n" :items="cAutoComplete[ item.param ]" @input.native="loadAutocomplete( $event, item )" autocomplete :disabled="false"></v-select> -->
                            <v-select v-show="role[ 'club_id' ]" v-model="role[ 'team_id' ]" :label="'params.team' | i18n" :items="teams" autocomplete :disabled="false"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <v-select v-model="role[ 'position' ]" :multiple="false" :items="getOptions( 'persons/getPositions', false )" :label="'params.position' | i18n" :disabled="false"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <v-text-field type="number" :label="'params.number' | i18n" :value="role[ 'number' ] | checkParam" @change="v => role[ 'number' ] = v" outline :rules="[]" ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <v-text-field type="number" :label="'params.tall' | i18n" :value="role[ 'altura' ] | checkParam" @change="v => role[ 'altura' ] = v" outline :rules="[]" ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <v-switch @change="v => role[ 'swim' ] = v" :label="'params.swim' | i18n"></v-switch>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <v-switch @change="v => role[ 'b_medicamento' ] = v" :label="'params.b_medicamento' | i18n"></v-switch>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <v-textarea outlined v-show="role['b_medicamento']" :label="'params.medicamento' | i18n" v-model="role['medicamento']"></v-textarea>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
            <v-flex xs12  v-else-if="[ 1, 2 ].includes( parseInt( role.contact_type_id ) )" class="player">
                <v-container>
                    <v-layout row wrap class="section">
                        <v-flex xs12 md6 class="item">
                            <!-- <v-select v-if="item.type == 'autocomplete' && item.param != 'country_id' && item.param != 'nacionality'" v-model="data[ item.param ]" :label="item.label | i18n" :items="cAutoComplete[ item.param ]" @input.native="loadAutocomplete( $event, item )" autocomplete :disabled="false"></v-select> -->
                            <v-select v-model="role[ 'contact_type_id' ]" :label="'params.role' | i18n" :items="[{text:'Entrenador', value: 1}, { text: '2n Entrenador', value: 2}]" autocomplete :disabled="false"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <!-- <v-select v-if="item.type == 'autocomplete' && item.param != 'country_id' && item.param != 'nacionality'" v-model="data[ item.param ]" :label="item.label | i18n" :items="cAutoComplete[ item.param ]" @input.native="loadAutocomplete( $event, item )" autocomplete :disabled="false"></v-select> -->
                            <v-select v-model="role[ 'event_id' ]" :label="'params.event' | i18n" :items="events_active" autocomplete :disabled="false"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <!-- <v-select v-if="item.type == 'autocomplete' && item.param != 'country_id' && item.param != 'nacionality'" v-model="data[ item.param ]" :label="item.label | i18n" :items="cAutoComplete[ item.param ]" @input.native="loadAutocomplete( $event, item )" autocomplete :disabled="false"></v-select> -->
                            <v-select v-show="role[ 'event_id' ]" v-model="role[ 'category_id' ]" :label="'params.category' | i18n" :items="categories" autocomplete :disabled="false"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <!-- <v-select v-if="item.type == 'autocomplete' && item.param != 'country_id' && item.param != 'nacionality'" v-model="data[ item.param ]" :label="item.label | i18n" :items="cAutoComplete[ item.param ]" @input.native="loadAutocomplete( $event, item )" autocomplete :disabled="false"></v-select> -->
                            <v-select v-show="role[ 'event_id' ] || role['club_id']" v-model="role[ 'club_id' ]" :label="'params.club' | i18n" :items="clubs" autocomplete :disabled="false"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <!-- <v-select v-if="item.type == 'autocomplete' && item.param != 'country_id' && item.param != 'nacionality'" v-model="data[ item.param ]" :label="item.label | i18n" :items="cAutoComplete[ item.param ]" @input.native="loadAutocomplete( $event, item )" autocomplete :disabled="false"></v-select> -->
                            <v-select v-show="role[ 'club_id' ]" v-model="role[ 'team_id' ]" :label="'params.team' | i18n" :items="teams" autocomplete :disabled="false"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <v-select v-model="role[ 'nivel' ]" :multiple="false" :items="getOptions( 'getStaffLevel', false )" :label="'params.nivel' | i18n" :disabled="false"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <v-switch v-model="role[ 'authoritzation' ]" :label="'params.authoritzation' | i18n"></v-switch>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
            <v-flex xs12  v-else class="player">
                <v-container>
                    <v-layout row wrap class="section">
                        <v-flex xs12 md6 class="item">
                            <!-- <v-select v-if="item.type == 'autocomplete' && item.param != 'country_id' && item.param != 'nacionality'" v-model="data[ item.param ]" :label="item.label | i18n" :items="cAutoComplete[ item.param ]" @input.native="loadAutocomplete( $event, item )" autocomplete :disabled="false"></v-select> -->
                            <v-select v-model="role[ 'contact_type_id' ]" :label="'params.role' | i18n" :items="[{text:'Delegat', value: 5}, { text: 'Directiu', value: 6}, { text: 'Altre', value: 108}, { text: 'Acompanyant', value: 110}, { text: 'Responsable', value: 111}]" :disabled="false"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <!-- <v-select v-if="item.type == 'autocomplete' && item.param != 'country_id' && item.param != 'nacionality'" v-model="data[ item.param ]" :label="item.label | i18n" :items="cAutoComplete[ item.param ]" @input.native="loadAutocomplete( $event, item )" autocomplete :disabled="false"></v-select> -->
                            <v-select v-model="role[ 'club_id' ]" :label="'params.club' | i18n" :items="clubs"  autocomplete :disabled="false"></v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="item">
                            <v-switch v-model="role[ 'authoritzation' ]" :label="'params.authoritzation' | i18n"></v-switch>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import i18n from '@/i18n'
import {Api} from '@/core/api.js';
const api = new Api();

export default {
    props: { role: Object, remove: Boolean },
    data () {
        return {
            event: false,
            aCategories: [],
            aClubs: [],
            aTeams: []
        }
    },
    computed: {
        countries(){
            var oCountries = this.$store.getters.getCountries()
            var aResult = []
            for( var k in oCountries ){
                aResult.push( { text: oCountries[k].name, value: oCountries[k].id } )
            }

            return aResult
        },

        events_active() {
            var aEvents = this.$store.getters['events/getActives']()
            var aResult = []
            var self = this
            aEvents.forEach( event => {
                aResult.push({
                    value: event.id,
                    text: self.$root.formatEventName( event.name, event.edition )
                })
            })
            return aResult
        },

        categories(){
            var aCategories = []
            var events = this.$store.getters['events/getActives']()
            for( var k in events ){
                if ( events[k].id == this.role.event_id ){
                    var event = events[k]
                    for( var j in event.categories ){
                        aCategories.push( { text: event.categories[j].name, value: event.categories[j].id } )
                    }
                }
            }

            return aCategories
        },

        clubs: {
            get(){
                return this.aClubs
            },
            set( clubs ){
                this.aClubs = clubs
            }    
        },

        teams: {
            get(){
                var aTeams = []
                for( var k in this.aTeams ){
                    var team = this.aTeams[k]
                    
                    if( team.club.id == this.role.club_id && team.category.id == this.role.category_id ){
                        aTeams.push( { text: team.name, value: team.id } )
                    }
                }

                return aTeams
            },
            set( teams ){
                this.aTeams = teams
            }
        }
    },
    methods: {
        getOptions( options, filter, bFirstEmpty ){
            var bFirstEmpty = ( typeof bFirstEmpty === 'undefined' )? false : bFirstEmpty
            if( typeof options === 'string' ){
                var aOptions = [];
                // console.log( options );
                // console.log( filter );
                if( typeof filter.params !== 'undefined' ){
                    var values = this.$store.getters[ options ]( filter.params );
                }
                else{
                    var values = this.$store.getters[ options ]();
                }
                if( bFirstEmpty ) aOptions.push( { value: -1, text: i18n.t( filter.label ) } );
                for( var i in values ){
                    var value = values[i];
                    name = ( typeof filter.translate === 'undefined' || filter.translate )? i18n.t( value.name ) : value.name;
                    aOptions.push( { value: value.id, text: name } );
                }

                return aOptions;
            }
            else {
                return options;
            }
        },

        fnRemove(){
            this.$emit( 'remove', this.role.id )
        }
    },
    created(){
        this.role.contact_type_id = parseInt( this.role.contact_type_id )
        if( this.role.event_id != null ){
            this.$overlay.loading()
            var self = this
            api.get( 'club/event/' + this.role.event_id ).then( function( response ){
                    if( response.status ){
                        var data = response.data;
                        var aClubs = []
                        for( var k in data ){ 
                            aClubs.push( { text: data[k].name, value: data[k].id } )
                        }

                        self.clubs = aClubs
                    }

                    self.$overlay.hide()
            })
        }
        else{
            api.get( 'club' ).then( function( response ){
                    if( response.status ){
                        var data = response.data;
                        var aClubs = []
                        for( var k in data ){ 
                            aClubs.push( { text: data[k].name, value: data[k].id } )
                        }

                        self.clubs = aClubs
                    }

                    self.$overlay.hide()
            })
        }
        if( this.role.club_id != null && this.role.event_id != null ){
            this.$overlay.loading()
            var self = this
            api.get( 'team/event/' + this.role.event_id ).then( function( response ){
                if( response.status ){
                    var data = response.data;
                    self.teams = data
                }

                self.$overlay.hide()
            })
        }
        
    },
    watch: {
        'role.event_id': {
            handler( newV, oldV ){
                if( newV != oldV ){
                    var self = this
                    api.get( 'club/event/' + this.role.event_id ).then( function( response ){
                        if( response.status ){
                            var data = response.data;
                            var aClubs = []
                            for( var k in data ){ 
                                aClubs.push( { text: data[k].name, value: data[k].id } )
                            }

                            self.clubs = aClubs

                            self.role.category_id = null
                            self.role.club_id = null
                            self.role.team_id = null
                        }

                        self.$overlay.hide()
                    })
                }
            },
            deep: true
        },

        'role.category_id': {
            handler( newV, oldV ){
                if( newV != oldV ){
                    this.$overlay.loading()
                    var self = this
                    api.get( 'club/event/' + this.role.event_id ).then( function( response ){
                        if( response.status ){
                            var data = response.data;
                            var aClubs = []
                            for( var k in data ){ 
                                aClubs.push( { text: data[k].name, value: data[k].id } )
                            }

                            self.clubs = aClubs
                            
                            self.role.team_id = null
                            self.role.club_id = null
                        }

                        self.$overlay.hide()
                    })
                }
            },
            deep: true
        },

        'role.club_id': {
            handler( newV, oldV ){
                if( newV != oldV ){
                    this.$overlay.loading()
                    var self = this
                    api.get( 'team/event/' + this.role.event_id ).then( function( response ){
                        if( response.status ){
                            var data = response.data;
                            self.teams = data
                            
                            self.role.team_id = null
                        }

                        self.$overlay.hide()
                    })
                }
            },
            deep: true
        },
    }
}
</script>

<style lang="scss" scoped>
    .layout {
        flex-direction: column;

        .name {
            &::after {
                background: none !important;
            }
        }
    }
</style>


